import { ReactNode, useCallback, useState } from 'react'
import { ActionStartingPointContext } from './context'

export const PlayListPopOverStartingPointProvider = ({
  children,
}: {
  children: ReactNode
}) => {
  const [element, setElement] = useState<HTMLElement | null>(null)

  const updateElement = useCallback((element: HTMLElement) => {
    setElement(element)
  }, [])

  return (
    <ActionStartingPointContext.Provider value={{ startPointElement: element, updateElement }}>
      {children}
    </ActionStartingPointContext.Provider>
  )
}
